import styled from 'styled-components';

import { Breakpoint } from '../../../enums';
import { StyledComponent } from '../../../interfaces';
import { FormField } from '../../formField/formField.component';

export const FormikForm: StyledComponent<'form'> = styled.form`
  width: 100%;
`;

export const FieldsRow: StyledComponent<'div'> = styled.div`
  width: 100%;
  display: flex;

  & + & {
    margin-top: 24px;
  }

  @media ${Breakpoint.Mobile} {
    flex-direction: column;
  }
`;

export const StyledFormField: StyledComponent<typeof FormField> = styled(FormField)`
  width: 100%;

  & + & {
    margin-left: 12px;
  }

  @media ${Breakpoint.Mobile} {
    & + & {
      margin-left: 0;
      margin-top: 24px;
    }
  }
`;
